import { combineReducers } from "redux";
import chargeReducer from "./chargeReducer";
import formDataReducer from "./formDataReducer";
import redirectionReducer from "./redirectionReducer";
import upiReducer from "./upiReducer";
import cardReducer from "./cardReducer";

const rootReducer = combineReducers({
  upiReducer,
  chargeReducer,
  redirectionReducer,
  formDataReducer,
  cardReducer
});

export default rootReducer;
